<template>
  <div id="app">
    <head-Back></head-Back>
    <div class="page">
      <div class="page-title">打开【本APP】的设置</div>

      <div class="page-desc">① APP【首页】左上角 - 【设置】</div>
      <img src="./img/s-local-1.png" />

      <div class="page-desc">② 打开【新消息通知】</div>
      <img src="./img/s-local-2.png" />

      <div class="page-desc">③ 打开前四个开关</div>
      <img src="./img/s-local-3.png" />

      <div class="page-title">这样就打开了APP里的消息通知</div>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-close";

export default {
  metaInfo: {
    title: "设置"
  },
  name: "app",
  data() {
    return {
      msg: "设置"
    };
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
}
.page {
  width: 690px;
  margin: 0 auto 100px auto;
}
.page-title {
  width: 100%;
  height: 50px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 50px;
  color: #333333;
  opacity: 1;
  text-align: center;
  margin: 30px auto 30px auto;
}
.page-desc {
  width: 100%;
  height: 44px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 44px;
  color: #333333;
  opacity: 1;
  text-align: left;
  margin: 40px auto 30px auto;
}
.page img {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/clac/settingLocal.vue